import { readConfig } from "./config.js";
import { ensureSession } from "./session.js";
import { loadFingerprint } from "./fingerprint.js";
import { createTransport } from "./transport.js";
import { installAutotrack } from "./autotrack.js";
import { exposeApi } from "./api.js";

(function main(): void {
  try {
    const cfg = readConfig();
    if (!cfg) return;

    const ids = ensureSession();
    const fp = loadFingerprint();
    const transport = createTransport(cfg);

    const getFp = (): string | undefined => fp.value;

    installAutotrack({ cfg, ids, getFp, transport });
    exposeApi(cfg, ids, getFp, transport);
  } catch {
    // Swallow all errors. A broken pixel must never break the customer's page.
  }
})();
